import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.get_response_xlk07e_k$().get_headers_ef25jx_k$() : headers;
  return DelegatedCall().new_io_ktor_client_call_DelegatedCall_k9u3ts_k$(_this__u8e3s4.client_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, originCall, responseContent, responseHeaders) {
        return new.target.new_io_ktor_client_call_DelegatedCall_k9u3ts_k$(client, originCall, responseContent, responseHeaders);
      }
      static new_io_ktor_client_call_DelegatedCall_k9u3ts_k$(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.get_response_xlk07e_k$().get_headers_ef25jx_k$() : responseHeaders;
        var $this = this.new_io_ktor_client_call_HttpClientCall_o2h3p8_k$(client);
        $this.request_1 = new (DelegatedRequest())($this, originCall.get_request_jdwg4m_k$());
        $this.response_1 = new (DelegatedResponse())($this, originCall.get_response_xlk07e_k$(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.$$delegate_0__1 = origin;
        this.call_1 = call;
      }
      get_call_wojxrb_k$() {
        return this.call_1;
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
      get_method_gl8esq_k$() {
        return this.$$delegate_0__1.get_method_gl8esq_k$();
      }
      get_url_18iuii_k$() {
        return this.$$delegate_0__1.get_url_18iuii_k$();
      }
      get_attributes_dgqof4_k$() {
        return this.$$delegate_0__1.get_attributes_dgqof4_k$();
      }
      get_content_h02jrk_k$() {
        return this.$$delegate_0__1.get_content_h02jrk_k$();
      }
      get_headers_ef25jx_k$() {
        return this.$$delegate_0__1.get_headers_ef25jx_k$();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.get_headers_ef25jx_k$() : headers;
        super();
        this.call_1 = call;
        this.origin_1 = origin;
        this.content_1 = content;
        this.headers_1 = headers;
        this.coroutineContext_1 = this.origin_1.get_coroutineContext_115oqo_k$();
      }
      get_call_wojxrb_k$() {
        return this.call_1;
      }
      get_headers_ef25jx_k$() {
        return this.headers_1;
      }
      get_rawContent_u3f8li_k$() {
        return this.content_1(this.origin_1);
      }
      get_coroutineContext_115oqo_k$() {
        return this.coroutineContext_1;
      }
      get_status_jnf6d7_k$() {
        return this.origin_1.get_status_jnf6d7_k$();
      }
      get_version_72w4j3_k$() {
        return this.origin_1.get_version_72w4j3_k$();
      }
      get_requestTime_wwxhg3_k$() {
        return this.origin_1.get_requestTime_wwxhg3_k$();
      }
      get_responseTime_scfvg7_k$() {
        return this.origin_1.get_responseTime_scfvg7_k$();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
